document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('custom-announcement')) {

        customElements.define('custom-announcement', class CustomAnnouncement extends HTMLElement {
          constructor() {
            super();
            this.slider = this;
            this.autoplay = this.getAttribute('data-autoplay');
            this.autoplaySpeed = parseInt(this.getAttribute('data-autoplay-speed'));
            this.grabCursor = this.getAttribute('data-grab-cursor');
          }

          connectedCallback() {
            this.init();
          }

          init() {
            var swiper = new Swiper(this.slider, {
              slidesPerView: 1,
              spaceBetween: 0,
              grabCursor: this.grabCursor === 'true',
              loop: true,
              autoplay: this.autoplay === 'true' ? { delay: this.autoplaySpeed } : false
            });
          }
      });
    }
  });